/** Maximum size for employee document / photo uploads (5 MiB). */
export const MAX_EMPLOYEE_ATTACHMENT_BYTES = 5 * 1024 * 1024;

/** Maximum size for employee video uploads (50 MiB). */
export const MAX_EMPLOYEE_VIDEO_BYTES = 50 * 1024 * 1024;
